import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const Box = styled.label`
  display: block;
  width: 100%;
  margin: 1.25rem 0;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

const Label = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  color: var(--gray);
  font-weight: 500;
  font-size: 0.8rem;
`

const InputElt = styled.input`
  display: block;
  width: 100%;
  padding: 0.75rem 0.5rem;
  border-radius: 0;
  background: var(--off-white);
  border: 1px solid transparent;
  &:focus {
    border: 1px solid var(--blue);
  }
`

export default class Input extends Component {
  render() {
    const { label, ...props } = this.props

    return (
      <Box>
        {label &&
          <Label>
            <Text str={label} />
          </Label>
        }
        <InputElt {...props} />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Input.js